import { Project } from '../types';

export const projects: Project[] = [
  {
    id: 'opennile',
    title: 'OpenNile',
    category: 'Website',
    description: 'A local marketplace for discovering nearby businesses, browsing products, and ordering pickup or delivery.',
    image: '/projects/opennile-hero.jpg',
    url: 'https://www.opennile.com/',
    technologies: ['Website']
  },
  {
    id: 'green-lakes',
    title: 'Green Lakes Homes',
    category: 'Website',
    description: 'Residential and HCBS care for people with disabilities and seniors across the Twin Cities.',
    image: '/projects/green-lakes.png',
    url: 'https://www.greenlakeshomes.com/',
    technologies: ['Website']
  },
  {
    id: 'brave-hearts',
    title: 'Brave Hearts Family',
    category: 'Website',
    description: 'Assisted living in St. Cloud with round-the-clock care, private rooms, and home-cooked meals.',
    image: '/projects/brave-hearts-hero.jpg',
    url: 'https://www.braveheartsfamily.com/',
    technologies: ['Website']
  },
  {
    id: 'ks-care',
    title: 'K&S Care Services',
    category: 'Website',
    description: 'Home care in Golden Valley, from companionship and homemaking to overnight and 24-hour support.',
    image: '/projects/ks-care.jpg',
    url: 'https://www.kscaregivers.com/',
    technologies: ['Website']
  },
  {
    id: 'teamrally',
    title: 'TeamRally',
    category: 'Website',
    description: 'Find local pickup games, players, and teams for basketball, soccer, volleyball, pickleball, and more.',
    image: '/projects/teamrally-hero.png',
    imageFit: 'natural',
    url: 'https://www.teamrallyapp.com/',
    technologies: ['Website']
  },
  {
    id: 'onway-bookings-site',
    title: 'OnWay Bookings',
    category: 'Website',
    description: 'A site for finding and booking local pros, from barbers and salons to cleaners, lawn care, and trades.',
    image: '/projects/onway-bookings-hero.jpg',
    imageFit: 'natural',
    url: 'https://onwaybookings.com/',
    technologies: ['Website']
  },
  {
    id: 'rivals',
    title: 'Rivals Sportsbook',
    category: 'Website',
    description: 'A social sportsbook for placing bets with friends across the games you follow.',
    image: '/projects/rivals.png',
    url: 'https://www.rivalssportsbook.com/',
    technologies: ['Website']
  },
  {
    id: 'onway-bookings-app',
    title: 'OnWay Bookings App',
    category: 'Mobile App',
    description: 'Book trusted local pros nearby, compare options, and pay securely from an iPhone or iPad.',
    image: '/projects/onway-bookings.jpg',
    url: 'https://apps.apple.com/us/app/onway-bookings/id6755271296',
    technologies: ['iOS']
  },
  {
    id: 'onway-pro',
    title: 'OnWay Pro',
    category: 'Mobile App',
    description: 'An app for service pros to list offerings, set hours, manage bookings, and accept cashless payments.',
    image: '/projects/onway-pro.jpg',
    url: 'https://apps.apple.com/us/app/onway-pro/id6755271707',
    technologies: ['iOS']
  }
];
